import { useRating } from '@risksmart-app/components/src/hooks/useRating';
import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { getFriendlyId } from '@/utils/friendlyId';

import type {
  OversightPerformanceFlatFields,
  OversightPerformanceRegisterFields,
} from './types';

export const useOversightPerformanceLabelledFields = (
  records: OversightPerformanceFlatFields[] | undefined
) => {
  const { t } = useTranslation(['common']);
  const effectiveness = useRating('effectiveness', 'oversight');
  const testTypeLookup = t('testTypes');

  return useMemo<OversightPerformanceRegisterFields[]>(() => {
    return (
      records?.map((d) => {
        const parent = d.parents.filter((a) => a.oversightAssessment)[0]
          ?.oversightAssessment;

        return {
          ...d,
          SubmitterName: d.submitter?.FriendlyName || '-',
          FriendlyID: getFriendlyId(
            Parent_Type_Enum.TestResult,
            d.SequentialId
          ),
          OverallEffectivenessLabelled: effectiveness.getLabel(
            d.OverallEffectiveness
          ),
          TestTypeLabelled:
            testTypeLookup[d.TestType as keyof typeof testTypeLookup] ?? '-',
          NextTestDate: parent?.NextTestDate ?? null,
          OversightAssessmentTitle: parent?.Title ?? '-',
        };
      }) || []
    );
  }, [effectiveness, records, testTypeLookup]);
};
